import _ from 'lodash';
import { batchActions } from 'redux-batched-actions';

import * as Sentry from '@sentry/browser';
import {
  Account,
  Profile,
  legacyAccountAndProfileCombo,
} from '@zapier/shared-entities';

import { trackEvent } from './utils/tracking';

const CLIENT_SIDE_PAGE_VIEW_EVENT = 'clientSidePageView';

function recordUserId(userId) {
  return trackEvent(CLIENT_SIDE_PAGE_VIEW_EVENT, {
    userId,
    eventCategory: 'CD',
    eventAction: 'RecordedUserId',
    eventLabel: userId,
  });
}

const recordUserIdOnce = _.once(recordUserId);

// All remaining z.* uses can be removed as soon as Dev Platform has left the monolith (or this code has left the monolith)

// Eventually, we'll remove this code. Just a few remaining
// places reading from the old account model.
// Make sure the account model exists, since technically there's a
// race condition with legacy/app.js to create it.
//
// Note for EDITOR team: we should be able to remove this function and the call to it below
// entirely once we copy the boneyard and leave the monolith.
const createLegacyBackboneModel = data => {
  if (_.isFunction(_.get(window.z, ['model', 'Account']))) {
    window.z.app.account = window.z.app.account || new window.z.model.Account();
    window.z.app.account.set(data);
  }
};

const setUserContext = profile => {
  Sentry.configureScope(scope => {
    scope.setUser({
      email: Profile.selectors.email(profile),
      id: Profile.selectors.id(profile),
    });
  });
};

const actions = {
  resetUserData() {
    return batchActions([
      Account.actions.resetCollection(),
      Profile.actions.resetCollection(),
    ]);
  },

  reloadAccount() {
    return actions.loadAccount(true);
  },

  loadAccount(shouldReload = false) {
    return (dispatch, getState) => {
      const actionCreators = shouldReload
        ? [
            Account.actions.forceLoadCollection,
            Profile.actions.forceLoadCollection,
          ]
        : [Account.actions.loadCollection, Profile.actions.loadCollection];
      return Promise.all(
        actionCreators.map(actionCreator => dispatch(actionCreator()))
      ).then(() => {
        const currentProfile = Profile.selectors.all.currentProfile(getState());
        if (currentProfile) {
          createLegacyBackboneModel(legacyAccountAndProfileCombo(getState()));
          setUserContext(currentProfile);
          recordUserIdOnce(Profile.selectors.id(currentProfile));
        }
      });
    };
  },
};

export default actions;
